import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { OrderService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalPayment extends React.Component<Props> {

	state = {
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await OrderService.admin.view({
			order_id: this.props.item?.id
		});
		this.setState({
			item: res.order
		});
	}

	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-delivery">
				<p><span>Nº Orden:</span> { item?.number }</p>
				{ item?.delivery?.delivery_type && <p><span>Forma de Entrega:</span> { item?.delivery?.delivery_type?.name }</p> }
				{ item?.delivery?.name && <p><span>Nombre:</span> { item?.delivery?.name }</p> }
				{ item?.delivery?.lastname && <p><span>Apellido:</span> { item?.delivery?.lastname }</p> }
				{ item?.delivery?.email && <p><span>Correo:</span> { item?.delivery?.email }</p> }
				{ item?.delivery?.phone && <p><span>Teléfono:</span> { item?.delivery?.phone }</p> }
				{ item?.delivery?.address && <p><span>Dirección:</span> { item?.delivery?.address }</p> }
				{ item?.delivery?.state && <p><span>Estado:</span> { item?.delivery?.state?.name }</p> }
				{ item?.delivery?.city && <p><span>Ciudad:</span> { item?.delivery?.city?.name }</p> }
				{ item?.delivery?.sector && <p><span>Sector:</span> { item?.delivery?.sector }</p> }
				{ item?.delivery?.postal_code && <p><span>Código Postal:</span> { item?.delivery?.postal_code }</p> }
				{ item?.delivery?.reference && <p><span>Referencia:</span> { item?.delivery?.reference }</p> }
				{ item?.delivery?.document && <p><span>Cédula/RIF:</span> { item?.delivery?.document_type?.name + item?.delivery?.document }</p> }
				<div className="text-center">
					<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalPayment;